import { render, staticRenderFns } from "./Textarea.vue?vue&type=template&id=7f2f2a00&scoped=true&"
import script from "./Textarea.vue?vue&type=script&lang=ts&"
export * from "./Textarea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2f2a00",
  null
  
)

export default component.exports